var collapsible_list_pair_rtlignore_default = {
  "container": "u1ftX",
  "title": "vlxUW",
  "viewerContainer": "kzbCN",
  "titleContainer": "_3wO3A",
  "expandIcon": "mspJH",
  "dndIcon": "fsETl",
  "RTL": "VFy9-",
  "LTR": "k-fn9",
  "itemContainer": "hUaur",
  "itemContainerViewer": "yaC-K",
  "mouseDown": "P1Wct",
  "innerEditor": "_4QJxr",
  "item": "tet8y",
  "floatingAddPluginMenuWrapper": "cyZFf",
  "childrenHidden": "uJJFX"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
